module.exports = __webpack_public_path__ + "img/section-close.2f100277.svg";